import useSWR from 'swr';
import axios from 'axios';

import { getApiUrl } from '@/helpers/api';

export const useCoaches = () => {
  const urlStr = `${getApiUrl()}/admin/coach`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useCoach = (id) => {
  const urlStr = `${getApiUrl()}/coach/${id}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useApproveCoach = () => {
  const approveCoach = async (id) => {
    try {
      const url = `${getApiUrl()}/admin/coach/${id}/approve`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return approveCoach;
};
